import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Checkbox } from 'antd';
import './index.css';
import { useNavigate, Navigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../utils/authentication';
import { trackUserLoginEnterSystem } from '../../utils/tracker';

const Login = () => {
  const { isAuthenticated, login } = useAuth();
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogin = async (values) => {
    setLoading(true);
    const { username, password } = values;
    try {
      const response = await axios.post('https://pai.geekyum.com/api/prime/auth/login', {
        username,
        password,
      });
      const { code, message: responseMessage, data } = response.data;

      if (code === 200) {
        const { token, userInfo, canDeleteOrder } = data;
        const authenticatedUserInfo = {
          ...(userInfo || {}),
          ...(canDeleteOrder === undefined ? {} : { canDeleteOrder }),
        };

        if (authenticatedUserInfo.userRole === 'EXTERNAL_API') {
          messageApi.error('The current user is a third-party API user and cannot access the internal system.');
          return;
        }

        login(token, authenticatedUserInfo);
        trackUserLoginEnterSystem();
        messageApi.success('Login Success');
        navigate('/workorder', { replace: true });
      } else {
        messageApi.error(responseMessage);
      }
    } catch (error) {
      messageApi.error(`Login Failure: ${error.message || error}`);
    }
    finally {
      setLoading(false);
    }
  };


  // 如果已经认证，直接跳转到工作订单页面
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/workorder', { replace: true });
    }
  }, [isAuthenticated, navigate]);


  if (isAuthenticated) {
    return <Navigate to="/workorder" replace />;
  }


  return (
    <div className="login-container">
      {contextHolder}

      <div className="login-logo"></div>

      <div className="login-card">
        {/* 左侧信息面板 */}
        <div className="login-info-panel">
          <div className="login-info-content">
            <div className="login-info-title">Welcome</div>
            <div className="login-info-line"></div>
            <div className="login-info-brand">Prime Shipping International, Inc.</div>
            <p className="login-info-desc">
              Professional freight forwarding<br />
              &amp; logistics management system.<br />
              Streamline HBL, work orders<br />
              and end-to-end shipment tracking.
            </p>
          </div>
          <div className="login-info-footer">
            <span>Shipping</span>
            <span className="login-info-sep">|</span>
            <span>Finance</span>
            <span className="login-info-sep">|</span>
            <span>Management</span>
          </div>
        </div>

        {/* 右侧登录表单 */}
        <div className="login-form-panel">
          <div className="login-login-title">Login</div>

          <Form
            name="login-form"
            onFinish={handleLogin}
            className="login-form"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Please Enter Account' }]}
            >
              <Input placeholder="Account" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please Enter Password' }]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>


            <Form.Item
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                color: 'ffffff',
                marginBottom: 6,
              }}>
              <Checkbox defaultChecked style={{ fontSize: 10, color: 'rgb(255, 255, 255)' }}>
                I agree to the
                <span style={{ color: 'rgb(91 210 26)', cursor: 'pointer', fontWeight: 'bold' }}> Terms of Service </span>
                and
                <span style={{ color: 'rgb(91 210 26)', cursor: 'pointer', fontWeight: 'bold' }}> Privacy Policy </span>
              </Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary" htmlType="submit" className="login-button" loading={loading}>
                Login
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
